import React from 'react';
import {
	Container,
	Navbar,
	NavbarToggler,
	NavItem,
	NavLink,
	Dropdown,
	DropdownToggle,
	DropdownMenu,
	DropdownItem,
	Button,
	UncontrolledDropdown,
	Modal,
	ModalHeader,
	ModalBody,
} from 'reactstrap';
import './NavMenu.css';
import { NavLink as RRNavLink } from 'react-router-dom';
import Cart from './Cart';
import locale from '../Locale';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actionCreators } from '../store/Configurator';
import Brands from './Brands';
import logoVarialis from '../images/Varialis.png';
import Helper from '../Helper';
import Languages from './Languages';
import Loading from 'react-fullscreen-loading';

interface IProps {
	user?: any;
	theme?: any;
	navCartOpen?: boolean;
	inquiryDialogOpen?: boolean;
	part?: any;
	configuration?: any;
	numberOfBrands?: number;
}

interface IState {
	isOpen: boolean;
	userOpen: boolean;
	cartOpen: boolean;
	inquiryDialogOpen: boolean;
	confirmationModal: boolean;
	confirmationModalTitle: string;
	confirmationModalMessage: string;
	confirmationModalAction: string;
	language: string;
	brand: any;
	loader: boolean;
}

class NavMenu extends React.Component<IProps, IState> {
	constructor(props: IProps) {
		super(props);
		this.state = {
			isOpen: false,
			userOpen: false,
			cartOpen: false,
			inquiryDialogOpen: false,
			confirmationModal: false,
			confirmationModalTitle: '',
			confirmationModalMessage: '',
			confirmationModalAction: '',
			language: '',
			brand: null,
			loader: this.props.configuration.loader,
		};
	}
	isExternalConfigurationPath() {
		const pathName = window.location.pathname.toLowerCase().replace(/\/$/, '');
		return pathName.indexOf('external-configurator') >= 0;
	}
	resetLoaderState() {
		(this.props as any).setConfigurationLoader(false);
		this.setState({ loader: false });

		const persistedState = localStorage.getItem('reduxState');
		if (persistedState) {
			try {
				const reduxState = JSON.parse(persistedState);
				if (reduxState.configurator?.configuration) {
					localStorage.setItem(
						'reduxState',
						JSON.stringify({
							...reduxState,
							configurator: {
								...reduxState.configurator,
								configuration: {
									...reduxState.configurator.configuration,
									loader: false,
								},
							},
						}),
					);
				}
			} catch {
				// ignore invalid persisted state
			}
		}
	}
	componentDidMount() {
		if (this.isExternalConfigurationPath() && this.props.configuration?.loader) {
			this.resetLoaderState();
		}
	}
	componentDidUpdate(prevProps: any) {
		if (prevProps.navCartOpen !== this.props.navCartOpen && this.props.navCartOpen === true) {
			this.setState({ cartOpen: true });
			(this.props as any).setCartOpen(false);
		}

		if (prevProps.inquiryDialogOpen !== this.props.inquiryDialogOpen && this.props.inquiryDialogOpen === true) {
			this.setState({ cartOpen: true });
			(this.props as any).setCartOpen(false);
		}

		if (prevProps.configuration.loader !== this.props.configuration.loader) {
			this.setState({ loader: this.props.configuration.loader });
		}
	}
	onLanguageSelect(lang: string) {
		if (this.isExternalConfigurationPath()) {
			this.confirmSetLanguage(lang);
		} else {
			localStorage.setItem('selectedLang', lang);
			this.toggleConfirmationModal();
		}
	}
	redirect() {
		if (this.state.confirmationModal) {
			this.toggleConfirmationModal();
		}
		const isExternalConfiguration = this.isExternalConfigurationPath();
		const pathName = window.location.pathname.toLowerCase().replace(/\/$/, '');

		if (!isExternalConfiguration) {
			(this.props as any).clearPart(true);
		}

		setTimeout(() => {
			if (isExternalConfiguration) {
				this.resetLoaderState();
				window.location.reload();
				return;
			} else if (Helper.userInstaller()) {
				window.location.href = process.env.REACT_APP_ROOT_PATH + '/admin/allProjects';
			} else if (Helper.userEditor()) {
				window.location.href = process.env.REACT_APP_ROOT_PATH + '/admin/myProjects';
			} else if (pathName.indexOf('documents') >= 0) {
				// eslint-disable-next-line no-self-assign
				window.location.href = window.location.href;
			} else {
				window.location.href = process.env.REACT_APP_ROOT_PATH + '/configurator/selection';
			}
		}, 700);
	}
	confirmSetLanguage(lang: string) {
		if (!this.isExternalConfigurationPath()) {
			(this.props as any).setConfigurationLoader(true);
			this.setState({ loader: true });
		}
		locale.setLanguage(lang);
		(this.props as any).setLanguage(lang);
		this.redirect();
	}
	confirmSetBrand(brand: any) {
		localStorage.setItem('theme', JSON.stringify(brand));
		localStorage.setItem('brandPartnerId', brand.brandPartnerId);
		(this.props as any).setBrand(
			brand.logo,
			brand.logotype,
			brand.title,
			brand.header,
			brand.color,
			brand.headerFontColor,
			brand.brandPartnerId,
			brand.buttonColor,
			brand.buttonFontColor,
			brand.showExposedBanner,
			brand.exposedBannerText,
			brand.exposedBannerUrl,
			brand.exposedBannerColor,
			brand.exposedBannerFontColor,
			brand.configuratorFavicon,
			brand.configuratorTitle,
		);
		this.redirect();
	}
	confirmationAction(action: string) {
		if (action === 'setLanguage') {
			this.confirmSetLanguage(this.state.language);
		} else if (action === 'setBrand') {
			this.confirmSetBrand(this.state.brand);
		}
	}
	toggleConfirmationModal() {
		const lang = localStorage.getItem('selectedLang') ?? '';
		const brand = localStorage.getItem('selectedBrand') ?? '';
		if (lang !== '') {
			this.setState({
				confirmationModal: !this.state.confirmationModal,
				confirmationModalTitle: locale.languageChange,
				confirmationModalMessage: locale.languageChangeConfirm,
				confirmationModalAction: 'setLanguage',
				language: lang,
			});
			localStorage.removeItem('selectedLang');
		} else if (brand !== '') {
			this.setState({
				confirmationModal: !this.state.confirmationModal,
				confirmationModalTitle: locale.brandChange,
				confirmationModalMessage: locale.brandChangeConfirm,
				confirmationModalAction: 'setBrand',
				brand: JSON.parse(brand),
			});
			localStorage.removeItem('selectedBrand');
		} else {
			this.setState({ confirmationModal: !this.state.confirmationModal });
		}
	}
	toggle() {
		this.setState((prev) => ({ isOpen: !prev.isOpen }));
	}
	userToggle() {
		this.setState((prev) => ({ userOpen: !prev.userOpen }));
	}
	cartToggle(open: boolean) {
		this.setState({ cartOpen: open });
	}
	render() {
		const pathName = window.location.pathname.toLowerCase().replace(/\/$/, '');

		const loggedIn = Helper.userLoggedIn();
		const headerTitle = this.props.theme && this.props.theme.header != null ? this.props.theme.header : locale.configurator;
		const isAdmin = Helper.userAdmin();
		const isInstaller = Helper.userInstaller();
		const isPublicDocuments = pathName.indexOf('documents') >= 0;
		const isExternalConfiguration = pathName.indexOf('external-configurator') >= 0;

		const logo = this.props.theme && this.props.theme.logo ? this.props.theme.logo : logoVarialis;
		const logotype = this.props.theme && this.props.theme.logotype ? this.props.theme.logotype : null;
		const themeHeaderColor = isPublicDocuments ? '#fff' : this.props.theme && this.props.theme.color ? this.props.theme.color : '#fff';

		const showBrandsSelection = this.props.numberOfBrands && this.props.numberOfBrands > 1;
		const { confirmationModal, confirmationModalMessage, confirmationModalTitle, confirmationModalAction } = this.state;

		const buttonColor = isPublicDocuments ? '#86a33c' : Helper.themeButtonColor();
		const buttonFontColor = isPublicDocuments ? '#000000' : Helper.themeButtonFontColor();

		const fontColor = isPublicDocuments
			? '#565658'
			: this.props.theme && this.props.theme.headerFontColor
				? this.props.theme.headerFontColor
				: '#565658';

		const configuratorFavicon = this.props.theme && this.props.theme.configuratorFavicon ? this.props.theme.configuratorFavicon : null;

		const configuratorTitle = this.props.theme && this.props.theme.configuratorTitle ? this.props.theme.configuratorTitle : null;

		const favicon = (document.querySelector("link[rel='icon']") as HTMLLinkElement) || document.createElement('link');

		if (favicon && configuratorFavicon) {
			favicon.href = `${configuratorFavicon}`;
		} else {
			favicon.href = `/favicon.ico`;
		}

		if (configuratorTitle && Helper.getLocalizedName(configuratorTitle)) {
			document.title = Helper.getLocalizedName(configuratorTitle);
		} else {
			document.title = locale.configuratorTitle;
		}

		return this.state.loader ? (
			<Loading loading loaderColor={buttonColor} />
		) : (
			<header>
				<Navbar style={{ backgroundColor: themeHeaderColor }} className='navbar-expand-sm navbar-toggleable-sm header-menu'>
					<Container fluid>
						<NavLink
							tag={RRNavLink}
							className='navbar-brand'
							to={
								process.env.REACT_APP_ROOT_PATH +
								(isExternalConfiguration
									? '/external-configurator/selection'
									: isAdmin
										? '/admin/myprojects'
										: isInstaller
											? '/admin/allprojects'
											: '/configurator/selection')
							}
							onClick={() => {
								window.location.href =
									process.env.REACT_APP_ROOT_PATH +
									(isExternalConfiguration
										? '/external-configurator/selection'
										: isAdmin
											? '/admin/myprojects'
											: isInstaller
												? '/admin/allprojects'
												: '/configurator/selection');
							}}
						>
							<img className='logo' alt='Logo' src={isPublicDocuments ? logoVarialis : logo} />
							<span className='logo-title' style={{ color: fontColor }}>
								{isPublicDocuments ? locale.configuratorPublic : headerTitle}
							</span>
						</NavLink>
						<NavbarToggler onClick={this.toggle} style={{ display: 'none' }} className='mr-2' />
						{logotype ? (
							<div className='outer-wrapper'>
								<div className='logo-frame'>
									<img className='logotip' alt='Logotype' src={logotype} />
								</div>
							</div>
						) : null}
						<ul className='navbar-nav flex-grow social'>
							{(isAdmin || isInstaller) && showBrandsSelection && loggedIn ? (
								<NavItem>
									<div>
										<UncontrolledDropdown>
											<DropdownToggle
												style={{
													backgroundColor: 'transparent',
													borderColor: fontColor,
													color: fontColor,
													borderWidth: '1px',
													borderStyle: 'solid',
													cursor: isExternalConfiguration ? 'default' : 'pointer',
												}}
												caret={!isExternalConfiguration ? true : false}
											>
												<span className='fa fa-copyright' style={{ marginLeft: '0px', fontSize: '33px', color: fontColor }} aria-hidden='true'></span>
												<span className='clearfix d-none d-lg-inline-block' style={{ color: fontColor }}>
													{this.props.theme && this.props.theme.title ? this.props.theme.title : locale.brands}
												</span>
											</DropdownToggle>
											{!isExternalConfiguration ? (
												<DropdownMenu style={{ width: 190 }}>
													<Brands toggleConfirmationModal={() => this.toggleConfirmationModal()} />
												</DropdownMenu>
											) : null}
										</UncontrolledDropdown>
									</div>
								</NavItem>
							) : null}
							<NavItem>
								<div>
									<UncontrolledDropdown>
										<DropdownToggle
											style={{
												backgroundColor: 'transparent',
												borderColor: fontColor,
												color: fontColor,
												borderWidth: '1px',
												borderStyle: 'solid',
											}}
											caret
										>
											<span className='fa fa-globe' style={{ marginLeft: '0px', fontSize: '33px', color: fontColor }} aria-hidden='true'></span>
											<span className='clearfix d-none d-lg-inline-block text-uppercase' style={{ color: fontColor }}>
												{Helper.userLang().replace('sl', 'si')}
											</span>
										</DropdownToggle>
										<DropdownMenu style={{ width: 80 }}>
											<Languages onLanguageSelect={(code) => this.onLanguageSelect(code)} />
										</DropdownMenu>
									</UncontrolledDropdown>
								</div>
							</NavItem>
							{!isAdmin && !isInstaller && !isPublicDocuments ? (
								<NavItem>
									<div>
										<Dropdown isOpen={this.state.cartOpen} toggle={() => this.cartToggle(true)}>
											<DropdownToggle
												style={{
													backgroundColor: 'transparent',
													borderColor: fontColor,
													color: fontColor,
													borderWidth: '1px',
													borderStyle: 'solid',
												}}
												caret
											>
												<span className='fa fa-cart-plus' style={{ marginLeft: '0px', fontSize: '33px', color: fontColor }} aria-hidden='true'></span>
												<span className='clearfix d-none d-lg-inline-block' style={{ color: fontColor }}>
													{locale.cart}
												</span>
											</DropdownToggle>
											<DropdownMenu right>
												<Button
													onClick={() => this.cartToggle(false)}
													color='cart-close'
													className='close float-right d-none d-md-block'
													aria-label='Close'
												>
													<span aria-hidden='true'>×</span>
												</Button>
												<Cart closeCart={() => this.cartToggle(false)} cartOpen={this.state.cartOpen} />
											</DropdownMenu>
										</Dropdown>
									</div>
								</NavItem>
							) : null}
							{!isPublicDocuments ? (
								<NavItem>
									<Dropdown isOpen={this.state.userOpen} toggle={() => this.userToggle()}>
										<DropdownToggle
											style={{
												backgroundColor: 'transparent',
												borderColor: fontColor,
												color: fontColor,
												borderWidth: '1px',
												borderStyle: 'solid',
												cursor: isExternalConfiguration ? 'default' : 'pointer',
											}}
											caret={!isExternalConfiguration ? true : false}
										>
											<span className='fa fa-user' style={{ marginLeft: '0px', fontSize: '33px', color: fontColor }} aria-hidden='true'></span>
											<span className='clearfix d-none d-lg-inline-block' style={{ color: fontColor }}>
												{loggedIn && this.props.user && this.props.user.name ? this.props.user.name : locale.unknownUser}
											</span>
										</DropdownToggle>
										{!isExternalConfiguration ? (
											<DropdownMenu right>
												<DropdownItem
													style={loggedIn ? { display: 'none' } : {}}
													tag={RRNavLink}
													disabled={loggedIn}
													to={process.env.REACT_APP_ROOT_PATH + '/Login'}
												>
													{locale.signIn}
												</DropdownItem>
												<DropdownItem
													style={!loggedIn ? { display: 'none' } : {}}
													tag={RRNavLink}
													disabled={!loggedIn}
													to={process.env.REACT_APP_ROOT_PATH + '/Profile'}
												>
													{locale.profile}
												</DropdownItem>
												<DropdownItem
													style={!loggedIn ? { display: 'none' } : {}}
													tag={RRNavLink}
													disabled={!loggedIn}
													to={process.env.REACT_APP_ROOT_PATH + '/Logout'}
												>
													{locale.signOut}
												</DropdownItem>
											</DropdownMenu>
										) : null}
									</Dropdown>
								</NavItem>
							) : null}
						</ul>
					</Container>
				</Navbar>
				<Modal size='lg' isOpen={confirmationModal} toggle={() => this.toggleConfirmationModal()}>
					<ModalHeader toggle={() => this.toggleConfirmationModal()}>{confirmationModalTitle}</ModalHeader>
					<ModalBody>
						{confirmationModalMessage}
						<br />
						<br />
						<Button
							className={'button btn-secondary my-2'}
							onClick={() => this.confirmationAction(confirmationModalAction)}
							style={{ backgroundColor: buttonColor, color: buttonFontColor }}
						>
							{locale.confirm}
						</Button>
						<Button
							className={'button btn-secondary my-2 ml-3'}
							onClick={() => this.toggleConfirmationModal()}
							style={{ backgroundColor: buttonColor, color: buttonFontColor }}
						>
							{locale.cancel}
						</Button>
					</ModalBody>
				</Modal>
			</header>
		);
	}
}
export default connect(
	(state: any) => state.configurator,
	(dispatch) => bindActionCreators(actionCreators, dispatch),
)(NavMenu);
